import { queryBrandActList } from "@/api/year-end-bonus";
import loadingPng from "@/base64";
import exposure from "@/utils/expose/exposure";
import { getCookie } from "@/utils/platform";
import { pxtorem } from "@/utils/pxtorem";
import Track from "@/utils/track";
import useNavigation from "@/utils/useNavigate";
import AKJS from "@akc/akjs";
import { Dialog, Image, Toast } from "antd-mobile";
import moment from "moment";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styles from "./brand-bole.module.less";
import ActivityBanner from "./components/activity-banner/activity-banner";
import ActivityStatus from "./components/activity-status/activity-status";
import EmptyStatus from "./components/empty-status";

const tipMaps = {
  "预计总奖励": "截止当前日期参与结对品牌预计可得总奖励之和",
};

const BrandBole: React.FC = () => {
  document.title = "品牌伯乐奖";
  const pageName = "品牌伯乐奖";
  const track = Track();

  const [search] = useSearchParams();
  const { navigate } = useNavigation();

  const [pageInfo, setPageInfo] = useState<any>({});
  const [brandList, setBrandList] = useState<any[]>([]);
  const [pageLoading, setPageLoading] = useState<boolean>(true);

  const toRulePage = () => {
    if (pageInfo?.planRule) {
      AKJS.action.dispatch("event.page.open", {
        url: pageInfo.planRule,
      });
    }
  };

  const getPageInfo = async () => {
    setPageLoading(true);
    // const data: any = await queryBrandPromotion();
    const result: any = await queryBrandActList();
    setBrandList(result?.brandList || []);
    setPageInfo(result || {});
    setPageLoading(false);
  };

  const showDialog = () => {
    Dialog.alert({
      title: "预计总奖励",
      content: tipMaps["预计总奖励"],
      confirmText: "我知道了",
      className: "dialog__private",
      // onConfirm: () => { },
    });
  };

  const toDetailPage = (activity, index) => {
    track.track("resource_click", {
      page_name: pageName,
      domain: "年终奖",
      module: "活动",
      resource_type: "活动卡片",
      resource_name: activity?.name,
      resource_rank: index,
      activity_id: activity?.actId,
      btn_name: "查看活动详情",
    });
    if (activity.startTime) {
      // startTime 为时间戳
      const startTime = moment(Number(activity.startTime));
      const now = moment();
      if (now.isBefore(startTime)) {
        Toast.show({
          content: "活动暂未开始，请耐心等待",
        });
        return;
      }
    }
    let envid: any = window.location.href.match(/[?&]env_identity=([^?#&]+)/);
    envid = envid && envid[1];
    navigate({
      appOptions: {
        url: `${origin}/mx-shop-micro/year-end-bonus/detail?actId=${activity.actId}&token=${search.get("token")}&shopId=${search.get(
          "shopId",
        )}&env_identity=${envid || getCookie("X-Hades-Env-Identity")}`,
      },
      h5Options: {
        url: "/mx-shop-micro/year-end-bonus/detail",
        query: {
          actId: activity.actId,
        },
      },
    });
  };

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     let flag = false;
  //     for (let i = 0; i < list.length; i++) {
  //       const dom = document.getElementById(`item-${i}`);
  //       if (dom) {
  //         exposure.add({
  //           el: dom,
  //         });
  //       } else {
  //         flag = true;
  //       }
  //       if (!flag) {
  //         clearInterval(interval);
  //       }
  //     }
  //   }, 1000);
  // }, [list]);

  useEffect(() => {
    getPageInfo();
    track.pageView(pageName, {
      domain: "年终奖",
    });
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.scroll_view}>
        {/* 规则 */}
        <img
          className={styles.rule__absolute}
          src="https://akim-oss.aikucun.com/mshop/8e8a120b7b795a6c5b7428427f5a3e67245d44d4_1731383104974_3.png"
          onClick={toRulePage}
        />
        {/* header */}
        <div className={styles.page__header}>
          {/* 活动状态 */}
          {pageInfo?.status === "BEGIN" && (
            <ActivityStatus
              sysTime={pageInfo.currentSysTime}
              taskEndTime={pageInfo.endTime}
              taskStatus={pageInfo.status}
              backgroundColor="radial-gradient(12% 88% at 92% 50%, #1B92FE 0%, #0A55FC 100%)"
              borderColor="rgba(255, 255, 255, 0.5)"
              textBackgroundColor="#0B3E96"
            />
          )}
        </div>
        {/* body */}
        <div className={styles.page__body}>
          {/* 数据展示 */}
          <div className={styles.body__data}>
            <div className={styles.data__list}>
              <div className={styles.list__item}>
                <div className={styles.item__value}>
                  {pageInfo?.totalAmount || 0}
                  <span className={styles.unit}>{pageInfo?.totalAmountUnit || "元"}</span>
                </div>
                <div className={styles.item__label}>
                  预计总奖励
                  <img
                    className={styles.icon}
                    src="https://akim-oss.aikucun.com/mshop/dc16dd3352577a826e74c056027382e2b5fbc772_1731119200062_62.png"
                    onClick={showDialog}
                  />
                </div>
              </div>
              <div className={styles.list__item}>
                <div className={styles.item__value}>
                  {pageInfo?.totalCount || 0}
                  <span className={styles.unit}>个</span>
                </div>
                <div className={styles.item__label}>参与活动数量</div>
              </div>
            </div>
            <div className={styles.data__bg}></div>
          </div>
          {/* 内容区域 */}
          <div className={styles.body__content}>
            {/* 活动标题 */}
            <div className={styles.actName}>- 我的活动 -</div>

            {/* 卡片列表 */}
            {brandList.map((item, index) => (
              <div
                key={item.actId}
                className={styles.content__activity}
                onClick={() => toDetailPage(item, index)}
                id={`item-${index}`}
                data-eventid={`item-${index}`}>
                <img
                  className={styles.activity__pic}
                  style={{ height: index === 0 ? pxtorem(150) : pxtorem(90) }}
                  src={
                    item.actImgUrl ||
                    "https://akim-oss.aikucun.com/mshop/31a296fbf428758527861b0c56c94538daef43ba_1731414035609_88.png"
                  }
                />
                <div className={styles.activity__info}>
                  <div className={styles.info__left}>
                    <h3>{item.name || ""}</h3>
                    <p>
                      活动时间：{moment(parseInt(item.startTime)).format("YYYY.MM.DD")}-
                      {moment(parseInt(item.endTime)).format("YYYY.MM.DD")}
                    </p>
                  </div>
                  <div className={styles.info__right}>
                    <div className={styles.right__btn}>查看活动详情</div>
                  </div>
                </div>
              </div>
            ))}
            {/* 空态 */}
            {brandList.length === 0 && <EmptyStatus />}
          </div>
        </div>
        {/* 业绩提升小妙招 */}
        <ActivityBanner pageName={pageName} />
      </div>
      {pageLoading && (
        <div className={styles.page__loading}>
          <Image src={loadingPng} width={pxtorem(30)}></Image>
        </div>
      )}
    </div>
  );
};

export default BrandBole;
